import React from "react";
import {
  Box,
  Stack,
  Typography,
  Avatar,
  Divider,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Button,
  Skeleton,
  Chip,
} from "@mui/material";
import { useParams, useNavigate, useOutletContext } from "react-router-dom";
import { useApiManager } from "lib/ApiContext";
import YouTubeHoverPreview from "../components/YouTubeHoverPreview";
import CommentsPanel from "../components/CommentsPanel";



const FullView = () => {
  const { publicationID } = useParams();

  const {
      loggedIn,
      openPublish,
      errorToShow,
      setShowLogin,
      avatarDirty,
      avatarSignedURL
    } = useOutletContext() || {};
  console.log(avatarDirty, avatarSignedURL, loggedIn);

  const navigate = useNavigate();
  const api = useApiManager();

  const [loading, setLoading] = React.useState(true);
  const [pub, setPub] = React.useState(null);

  const [creator, setCreator] = React.useState(null);
  const [logoURL, setLogoURL] = React.useState(null);

  // ----- Load publication + creator -----
  const loadPublication = React.useCallback(async () => {
    if (!api || !publicationID) return;
    setLoading(true);
    try {
      let p = null;

      // Prefer a direct endpoint if exists
      if (api.GetPublication) {
        p = await api.GetPublication(publicationID);
        p = p.Publication;
      }

      if (!p) {
        setPub(null);
        setLoading(false);
        return;
      }

      setPub(p);

      // Load creator info + logo
      if (p.Creator !== -1) {
        const c = await api.GetCreator(p.Creator);
        setCreator(c);
        if (c?.Logo) {
          const logo = await api.GetImageURL(c.Logo);
          setLogoURL(logo?.url || null);
        }
      }
    } catch (e) {
      console.error("Error loading publication", e);
    } finally {
      setLoading(false);
    }
  }, [api, publicationID, loggedIn]);


  React.useEffect(() => {
    loadPublication();
  }, [loadPublication, loggedIn, avatarDirty]);

  // ----- Render helpers -----
  const renderMedia = () => {
    if (!pub) return null;

    const publishType = Number(pub.PublishType || 0);
    // 2 = YouTube, 1 = photos (placeholder), else text only
    if (publishType === 2 && pub.VideoURL) {
      return (
        <YouTubeHoverPreview
          video={pub.VideoURL}
          width="100%"
          height={420}
        />
      );
    }
    if (publishType === 1) {
      return (
        <Box
          sx={{
            width: "100%",
            height: 360,
            border: "1px dashed rgba(199,125,255,.4)",
            borderRadius: 1,
            display: "grid",
            placeItems: "center",
            color: "#A8A3B8",
            bgcolor: "#14141F",
          }}
        >
          (Galería de fotos próximamente)
        </Box>
      );
    }
    return null;
  };

  return (
    <Box
      sx={{
        maxWidth: 980,
        mx: "auto",
        mt: 4,
        px: { xs: 1.5, sm: 2 },
      }}
    >
      {/* Header (creator + user publisher) */}
      <Box
        sx={{
          bgcolor: "#14141F",
          borderRadius: "10px",
          border: "1px solid rgba(237,233,247,0.08)",
          p: 2,
        }}
      >
        {loading ? (
          <Stack direction="row" spacing={2} alignItems="center">
            <Skeleton variant="circular" width={48} height={48} />
            <Box sx={{ flex: 1 }}>
              <Skeleton width="40%" />
              <Skeleton width="25%" />
            </Box>
          </Stack>
        ) : (
          <Stack direction="row" spacing={2} alignItems="center">
            <Avatar
              src={logoURL || undefined}
              sx={{ width: 48, height: 48, bgcolor: "#9D00FF" }}
              onClick={() =>
                creator?.Nickname &&
                navigate(`/creators/${creator.Nickname}`)
              }
              role="button"
            >
              {(creator?.Name?.charAt?.(0) || "?").toUpperCase()}
            </Avatar>

            <Box>
              <Typography
                sx={{
                  fontWeight: 700,
                  fontSize: "2rem",
                  color: "#C77DFF",
                  cursor: "pointer",
                }}
                onClick={() =>
                  creator?.Nickname &&
                  navigate(`/creators/${creator.Nickname}`)
                }
              >
                {creator?.Name || "Creator"}
              </Typography>

              <Typography sx={{ color: "#A8A3B8", fontSize: ".9rem" }}>
                Publicado por:{" "}
                <strong>{pub?.UserPublisher || pub?.User || "Usuario"}</strong>
              </Typography>
            </Box>
          </Stack>
        )}

        {/* Title */}
        <Typography
          sx={{
            mt: 2,
            color: "#EDE9F7",
            fontSize: "1.25rem",
            fontWeight: "bold",
            fontFamily: "'Space Grotesk', sans-serif",
          }}
        >
          {loading ? <Skeleton width="60%" /> : pub?.Title}
        </Typography>

        {/* Media */}
        <Box sx={{ mt: 2 }}>{loading ? <Skeleton height={420} /> : renderMedia()}</Box>

        {/* Description */}
        <Typography
          sx={{
            mt: 2,
            color: "#EDE9F7",
            fontSize: "1rem",
            lineHeight: 1.5,
            whiteSpace: "pre-wrap",
          }}
        >
          {loading ? (
            <>
              <Skeleton />
              <Skeleton width="90%" />
              <Skeleton width="70%" />
            </>
          ) : (
            pub?.Description
          )}
        </Typography>
      </Box>
 
      {/* Comments */}
+     <CommentsPanel publicationID={publicationID} loggedIn={loggedIn} setShowLogin={setShowLogin} avatarDirty={avatarDirty} avatarUrl={avatarSignedURL} />
      
    </Box>
  );
};

export default FullView;
